import Repository from "../../Helpers/Repository";
import SortableSchedules from "../Helpers/SortableSchedules";
import GroupedStages from "../Helpers/GroupedStages";

export default class ScheduleApiService {
    static getEventDays() {
        return new Repository().getEventDays().then((response) => {
            if (response.data['event_days'].length <= 0) {
                return null;
            }

            const event_days = [];
            const current_year = new Date().getFullYear();

            response.data['event_days'].forEach((event_day) => {
                if (new Date(event_day).getFullYear() === current_year) {
                    event_days.push(event_day);
                }
            });

            return event_days;
        });
    }

    static getStages() {
        return new GroupedStages().build();
    }

    static getSchedules(day = null, stage_id = null, search = null) {
        return new Repository().getSchedules(day, stage_id, null, search).then(async (response) => {
            return new SortableSchedules(response.data.data ?? []);
        });
    }
}
